<script setup lang="ts">
import { Loader2 } from '@lucide/vue'
import { Button, type ButtonVariants } from '@/components/ui/button'

/**
 * Bouton qui déclenche un appel réseau (SP-27) : tant que `loading` est vrai, il est
 * désactivé, annoncé `aria-busy`, et un spinner remplace l'icône de tête. Le libellé
 * reste en place pour que la largeur ne saute pas. Les autres attributs (`type`,
 * `variant`, `size`, `class`, `@click`) passent au bouton shadcn tels quels.
 */
defineProps<{
  loading?: boolean
  disabled?: boolean
  variant?: ButtonVariants['variant']
  size?: ButtonVariants['size']
}>()
</script>

<template>
  <Button
    :variant="variant"
    :size="size"
    :disabled="disabled || loading"
    :aria-busy="loading || undefined"
    :class="loading && '[&>svg:not([data-spinner])]:hidden'"
  >
    <Loader2 v-if="loading" data-spinner class="animate-spin" aria-hidden="true" />
    <slot />
  </Button>
</template>
